export default function isEducationalEmail(email) {
  if (!email || typeof email !== 'string') return false;

  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;

  // Matches common educational patterns
  const eduDomainPatterns = [
    /\.edu$/, // ends in .edu
    /\.k12\.[a-z]{2}\.us$/, // e.g., school.k12.tx.us
    /school/, // contains 'school'
    /district/, // contains 'district'
    /k12/, // contains 'k12'
    /edu/, // contains 'edu'
    /\.education$/,                  // Modern TLD
    /\.school$/,                     // Modern TLD
    /\.academy$/,                    // Modern TLD
    /\.college$/,                    // Modern TLD
    /\.institute$/,                  // Modern TLD
    /\.sch\.uk$/,                    // UK school domains
    /school/,                        // Domain includes 'school'
    /district/,                      // Domain includes 'district'
    /k12/,                           // Domain includes 'k12'
    /edu/,                           // Domain includes 'edu'
    /\.cc\.[a-z]{2}\.us$/, // some community colleges
  ];

  return eduDomainPatterns.some(pattern => pattern.test(domain));
}

